import * as Yup from 'yup';

export const VerificationSchema = Yup.object().shape({
  email: Yup.string().email('Invalid email').required('Email is required'),
  mobile: Yup.string()
    .min(10, 'Invalid mobile number')
    .max(10, 'Mobile number should be 10 digit')
    .required('Mobile number is required'),
});
